import { useCallback } from 'react';
import { chatListFamily } from '../states/chat';
import { useAtomCallback } from 'jotai/utils';
import { useAtomValue } from 'jotai';
import { ChatProviderType, ChatType } from '../components/chat-list-section/chat-row/typings';
import { selectedChatIdsListAtom } from '../states/chat-list';

export const useSelectedChatsIncludeProviderTypes = (providerTypes: ChatProviderType[]) => {
  const selectedChatIdsList = useAtomValue(selectedChatIdsListAtom);
  return useAtomCallback(
    useCallback(
      (get) => {
        return selectedChatIdsList.some((chatID) => {
          const chatProviderType = get(chatListFamily({ id: chatID }))?.providerType;
          return chatProviderType && providerTypes.includes(chatProviderType);
        });
      },
      [selectedChatIdsList, providerTypes]
    )
  );
};
